import { secureRefSplitApi } from './ref-api';

const expenseEvalVerificationDiscountTypesApi =
  secureRefSplitApi.injectEndpoints({
    endpoints: (build) => ({
      fetchExpenseEvalVerificationDiscountTypes: build.query<
        { label: string; value: string }[],
        void
      >({
        query: () => ({
          url: '/expense-evaluation-verification-discount-types',
          method: 'GET'
        })
      })
    }),
    overrideExisting: false
  });

export const { useFetchExpenseEvalVerificationDiscountTypesQuery } =
  expenseEvalVerificationDiscountTypesApi;
